import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Banner from "./components/Banner";
import Overview from "./components/Overview";
import Image from "../../assets/Banner/banner2.jpg";

const styles = {
  paperContainer: {
    height: 350,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const About = () => {
  return (
    <Box>
      <Helmet>
        <title> Overview | States Fiscal Transparency League</title>
      </Helmet>
      <Box style={styles.paperContainer}>
        <Banner />
      </Box>
      <Box>
        <Container>
          <Overview />
        </Container>
      </Box>
    </Box>
  );
};

export default About;
